<!-- src/components/ProductLabel.vue -->
<template>
    <div class="item-tags" v-if="processedLabels">
      <div
        class="item-tag"
        v-if="typeof processedLabels === 'string'"
      >
        {{ processedLabels }}
      </div>
      <template v-else-if="Array.isArray(processedLabels)">
        <div
          v-for="(label, index) in processedLabels"
          :key="index"
          class="item-tag"
        >
          {{ label }}
        </div>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ProductLabel',
    props: {
      productLabel: {
        type: [String, Array],
        default: null
      }
    },
    computed: {
      processedLabels() {
        if (!this.productLabel) {
          return null;
        }
        
        if (Array.isArray(this.productLabel)) {
          return this.productLabel;
        }
        
        // 如果是字符串，判断是否为 JSON
        if (typeof this.productLabel === 'string') {
          try {
            const parsed = JSON.parse(this.productLabel);
            if (Array.isArray(parsed) || typeof parsed === 'string') {
              return parsed;
            }
            return this.productLabel;
          } catch (e) {
            // JSON 解析失败，返回空
            return null;
          }
        }
        
        // 其他情况返回 null
        return null;
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .item-tags {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    max-width: 100%;
    box-sizing: border-box;
    padding: 10px 0 8px;
    gap: 8px;
  
    .item-tag {
      color: #212322;
      font-family: Noto Sans CJK SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      padding: 0 8px;
      border: 1px solid #acacac;
      background: #fff;
    }
  }
  </style>